import { sql } from "drizzle-orm";
import { pgTable, uuid, text, timestamp, jsonb, index } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { conversations } from "./chat";
export var ActionKind;
(function (ActionKind) {
    ActionKind["EMAIL_DRAFT"] = "email_draft";
    ActionKind["NOTION_DOC"] = "notion_doc";
    ActionKind["LINEAR_TASK"] = "linear_task";
    ActionKind["SLACK_MESSAGE"] = "slack_message";
    ActionKind["GCAL_RSVP"] = "gcal_rsvp";
    ActionKind["GCAL_UPDATE_TIME"] = "gcal_update_time";
    ActionKind["GCAL_CREATE_EVENT"] = "gcal_create_event";
    ActionKind["GCAL_ADD_DESCRIPTION"] = "gcal_add_description";
    ActionKind["GCAL_ADD_CONFERENCE"] = "gcal_add_conference";
    ActionKind["GCAL_CANCEL"] = "gcal_cancel";
})(ActionKind || (ActionKind = {}));
export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["DRAFT"] = "draft";
    ActionStatus["APPROVED"] = "approved";
    ActionStatus["COMPLETED"] = "completed";
    ActionStatus["FAILED"] = "failed";
    ActionStatus["REJECTED"] = "rejected";
    ActionStatus["IN_PROGRESS"] = "in_progress";
})(ActionStatus || (ActionStatus = {}));
export const actions = pgTable("actions", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    conversationId: uuid("conversation_id").references(() => conversations.id, {
        onDelete: "set null",
    }),
    kind: text("kind").notNull().$type(), // email_draft, notion_doc, linear_task, slack_message
    status: text("status").notNull().$type(), // DRAFT, SENT, APPROVED, FAILED
    title: text("title").notNull(),
    narration: text("narration").notNull(),
    link: text("link"),
    payload: jsonb("payload").notNull().default({}),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    executedAt: timestamp("executed_at", { withTimezone: true }),
    outcome: jsonb("outcome_jsonb").$type().default(null),
    error: text("error"),
}, table => ({
    companyCreatedIdx: index("idx_actions_company_created").on(table.companyId, table.createdAt),
    kindIdx: index("idx_actions_kind").on(table.kind),
    statusIdx: index("idx_actions_status").on(table.status),
    conversationIdx: index("idx_actions_conversation").on(table.conversationId, table.createdAt),
    briefIdIdx: index("idx_actions_brief_id").on(sql `(${table.payload}->>'briefId')`),
}));
